var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "address-card well relative mb-3",
      class: [
        _vm.isLocalizable(_vm.address) ? "active" : "disabled",
        { selected: _vm.selected }
      ],
      on: {
        click: function($event) {
          return _vm.selectAddress(_vm.address)
        }
      }
    },
    [
      _c("h4", { staticClass: "mt-0" }, [
        _vm._v("\n        " + _vm._s(_vm.address.name) + "\n        "),
        _c("span", { staticClass: "grey ml-2" }, [
          _vm._v(
            _vm._s(
              _vm.address.mainAddress ? _vm.$l10n.__("Adresse principale") : ""
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "m-0" }, [
        _c("li", { staticClass: "mb-2" }, [_vm._v(_vm._s(_vm.address.part1))]),
        _vm._v(" "),
        _vm.address.part2 != ""
          ? _c("li", { staticClass: "mb-2" }, [
              _vm._v(_vm._s(_vm.address.part2))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.address.part2 != ""
          ? _c("li", { staticClass: "mb-2" }, [
              _vm._v(_vm._s(_vm.address.part3))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.address.part2 != ""
          ? _c("li", { staticClass: "mb-2" }, [
              _vm._v(_vm._s(_vm.address.part4))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("li", { staticClass: "mb-2" }, [
          _vm._v(_vm._s(_vm.address.zip) + " " + _vm._s(_vm.address.town))
        ]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.address.countrycode))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }